// var PREFIX = window.location.protocol + '//';
var HOST = window.location.href;
var ROOT = (/rbthtml/gi.test(HOST)
  ? 'https://xiandan.mynatapp.cc/'
  : 'https://diantoushi.com/');
// ROOT = 'https://xiandan.mynatapp.cc/';
// ROOT = 'https://diantoushi.com/';
const API = {
  blackData: 'chaheihao/data', // 查黑号数据统计
  login: 'user/login',
  captchaLogin: 'user/captcha/login', // 验证码登录
  loginout: 'user/loginout',
  userInfo: 'user/info', // 用户信息详情
  checkBlack: 'chaheihao/getV4', // 查黑号
  // checkLabel: 'wangwang/tagv2', // 验标签
  checkLabel: 'wangwang/v4/tag', // 验标签
  getTags: 'chaheihao/getTags', // 标签实时查询
  getcaptcha: 'user/v3/captcha', // 获取验证码
}
export {
  API, ROOT
};